import { useId } from 'react';

import {
  type HTMLChakraProps,
  type ThemingProps,
  chakra,
  useTheme,
} from '@chakra-ui/react';

export const Illustration403 = ({
  colorScheme = 'brand',
  ...rest
}: HTMLChakraProps<'svg'> & { colorScheme?: ThemingProps['colorScheme'] }) => {
  const clipPathId01 = useId();
  const theme = useTheme();
  return (
    <chakra.svg
      width={300}
      maxW="full"
      viewBox="0 0 200 200"
      fill="none"
      {...rest}
    >
      <g clipPath={`url(#${clipPathId01})`}>
        <path
          d="M160.055 37.54c-12.448-8.272-27.496-11.371-43.697-4.362-16.015 6.928-24.232 23.29-38.08 33-14.73 10.324-33.92 11.448-49.896 19.436C17.095 91.27 9.48 101.726 7.848 114.272c-3.193 24.566 10.32 49.417 33.182 59.283 14.26 6.153 30.74 5.805 44.914-.424 10.88-4.778 20.289-12.444 31.126-17.417 18.817-8.65 40.853-8.226 58.784-19.22 18.978-11.626 21.102-32.335 16.396-51.444-4.278-17.367-16.053-36.778-32.195-47.51z"
          fill="currentColor"
          opacity={0.05}
        />
        <path
          d="M92.449 177.626c-12.241 0-23.482-2.095-33.412-6.22-17.015-7.077-31.588-21.018-38.978-37.312a60.743 60.743 0 01-1.476-3.545c-4.96-12.936-6.236-27.814-3.688-43.032 3.73-22.293 15.047-41.64 31.037-53.072 12.295-8.79 27.72-13.627 43.451-13.627 4.793 0 9.576.45 14.285 1.344 13.508 2.574 24.927 9.468 32.156 19.407a234.013 234.013 0 013.701 5.35c2.633 3.897 5.118 7.582 8.349 11.024 5.168 5.512 11.024 10.388 15.556 14.022 4.533 3.634 9.193 7.747 13.306 13.746a57.183 57.183 0 017.67 16.888c8.213 29.676-14.12 55.065-40.424 64.817-12.538 4.664-31.661 10.197-51.53 10.197l-.003.013z"
          fill={theme.colors[colorScheme][900]}
        />
        <path
          d="M171.517 108.04c-2.116-1.528-4.398.877-2.771 2.911 2.115 1.528 4.403-.877 2.771-2.911zM152.275 116.664a1.004 1.004 0 10-1.381 1.457 1.004 1.004 0 001.381-1.457zM173.89 95.23a.972.972 0 10.036 1.945.972.972 0 00-.036-1.944z"
          fill={theme.colors.white}
        />
        <path
          d="M48.135 115.221c.425-5.348-3.566-10.028-8.914-10.452-5.348-.425-10.027 3.566-10.452 8.914-.425 5.348 3.566 10.027 8.914 10.452 5.348.424 10.027-3.567 10.452-8.914z"
          fill={theme.colors.white}
        />
        <path
          d="M43.215 109.118l4.872 6.491a9.633 9.633 0 00-.312-3.842l-4.56-2.649zM33.257 106.257l11.585 15.508a9.632 9.632 0 002.215-2.834l-9.741-14.116a9.754 9.754 0 00-4.059 1.442zM38.351 124.151l-5.035-6.834 2.712 6.527a9.39 9.39 0 002.323.307zM42.265 123.374l-11.49-14.871c-.103.136-.198.28-.298.425l8.403 15.228a9.76 9.76 0 003.385-.782z"
          fill={theme.colors[colorScheme][300]}
        />
        <path
          d="M125.134 157.875a3.128 3.128 0 10-6.245-.35 3.128 3.128 0 006.245.35zM115.893 153.281c-.181 1.64-.357 1.808-1.989 2.092 1.641.181 1.808.357 2.093 1.989.181-1.645.357-1.831 1.989-2.093-1.645-.18-1.831-.357-2.093-1.988z"
          fill={theme.colors.white}
        />
        <path
          d="M147.075 143.377a6.288 6.288 0 10-2.49-12.326 6.288 6.288 0 002.49 12.326z"
          fill={theme.colors.white}
        />
        <path
          d="M143.348 133.007a4.756 4.756 0 00-1.605-.57 6.166 6.166 0 011.449-.934c.655.252 1.292.551 1.905.893 2.649 1.494 2.006 1.439 5.457 1.904.318.042.632.113.937.212.197.413.349.846.455 1.292.174.772.201 1.571.079 2.354-1.221-.086-2.861-.303-3.721-.844-1.448-.911-2.064-2.659-4.956-4.307zM151.244 140.409a6.243 6.243 0 01-1.326 1.587c-1.321-.536-2.044-1.261-3.843-1.631-1.574-.323-3.965.072-5.455.391a6.263 6.263 0 01-.93-2.117l-.064-.315a18.081 18.081 0 015.332.007c2.546.366 4.048 1.751 6.286 2.078zM143.698 135.445c-.962.789-2.694.885-4.077.823.104-.681.32-1.34.639-1.95 1.796-.082 4.766.033 3.438 1.127z"
          fill={theme.colors[colorScheme][300]}
        />
        <path d="M147.445 131.032c7.16-1.082 13.434-.316 13.965 2.021.623 2.742-6.045 6.597-14.928 8.622-8.883 2.025-16.567 1.442-17.19-1.296-.565-2.477 4.842-5.87 12.437-7.99" />
        <path d="M148.453 131.091c4.471-.373 7.897.471 8.3 2.28.534 2.35-4.21 5.434-10.598 6.89-6.388 1.456-12.007.733-12.542-1.617-.451-1.961 2.793-4.438 7.586-6.047" />
        <path
          d="M161.68 135.073a1.074 1.074 0 00-.872-.824 1.08 1.08 0 10.445 1.947 1.07 1.07 0 00.427-1.123zM134.809 138.195a1.079 1.079 0 00-1.969-.332 1.083 1.083 0 001.833 1.147 1.08 1.08 0 00.136-.815z"
          fill={theme.colors[colorScheme][300]}
        />
        <path
          d="M85.584 35.349a1.246 1.246 0 11-2.493 0 1.246 1.246 0 012.493 0zM73.397 168.518a1.246 1.246 0 11-2.492 0 1.246 1.246 0 012.492 0zM161.857 83.947a1.245 1.245 0 01-2.471.23 1.249 1.249 0 01.548-1.277 1.248 1.248 0 011.567.172c.229.233.358.548.356.875zM28.704 93.47a1.247 1.247 0 100-2.493 1.247 1.247 0 000 2.493zM49.124 52.63a1.247 1.247 0 100-2.492 1.247 1.247 0 000 2.493zM99.775 30.244a.623.623 0 11-1.245-.009.623.623 0 011.245.009zM87.588 163.413a.623.623 0 11-1.246-.009.623.623 0 011.246.009zM119.033 51.198a.62.62 0 01-.746.61.622.622 0 01.127-1.234.616.616 0 01.619.624zM34.038 66.356a.623.623 0 100-1.247.623.623 0 000 1.247zM55.196 49.357a.623.623 0 11-1.246.01.623.623 0 011.246-.01zM83.897 29.078a.623.623 0 100-1.247.623.623 0 000 1.247zM71.71 162.247a.623.623 0 10-.001-1.247.623.623 0 000 1.247zM100.017 63.413a.623.623 0 100-1.246.623.623 0 000 1.246zM20.241 117.571a.624.624 0 10-.001-1.248.624.624 0 00.001 1.248zM30.612 126.882a.623.623 0 100-1.247.623.623 0 000 1.247zM26.495 130.676a.623.623 0 100-1.246.623.623 0 000 1.246zM68.81 31.401a.623.623 0 100-1.246.623.623 0 000 1.246zM56.623 164.57a.623.623 0 100-1.246.623.623 0 000 1.246zM79.847 61.204a.623.623 0 100-1.247.623.623 0 000 1.247zM89.085 59.214a3.019 3.019 0 10-.965-5.96 3.019 3.019 0 00.965 5.96zM49.945 135.443a3.02 3.02 0 10-.966-5.961 3.02 3.02 0 00.966 5.961zM24.104 82.366a3.019 3.019 0 100-6.038 3.019 3.019 0 000 6.038zM44.855 69.413a1.878 1.878 0 100-3.757 1.878 1.878 0 000 3.757zM115.688 85.236a1.878 1.878 0 100-3.756 1.878 1.878 0 000 3.756zM118.52 34.827c-1.505-.208-1.67-.373-1.878-1.878-.204 1.505-.369 1.67-1.874 1.878 1.505.203 1.67.369 1.874 1.874.208-1.505.373-1.67 1.878-1.874zM106.333 167.996c-1.505-.208-1.671-.373-1.878-1.878-.204 1.505-.369 1.67-1.874 1.878 1.505.204 1.67.369 1.874 1.874.207-1.505.373-1.67 1.878-1.874z"
          fill={theme.colors.white}
        />
        <path
          d="M100.148 51C93.398 57.42 76.133 63.907 56 77.665c0 0 1.257 46.49 44.148 71.904V51z"
          fill={theme.colors[colorScheme][300]}
        />
        <path
          d="M100.148 51c6.745 6.42 24.015 12.907 44.149 26.665 0 0-1.257 46.49-44.149 71.904V51z"
          fill={theme.colors[colorScheme][700]}
        />
        <path
          d="M100.148 54.958c-8.143 5.772-22.256 11.275-40.91 24.02 0 0 1.166 43.074 40.91 66.633 39.745-23.549 40.911-66.633 40.911-66.633-18.659-12.74-32.706-18.248-40.911-24.02z"
          fill={theme.colors[colorScheme][900]}
        />
        <path
          d="M134.086 74.402c-28.46 8.615-50.169 33.623-60.04 46.814a81.543 81.543 0 0026.102 24.395c39.745-23.549 40.911-66.633 40.911-66.633a236.48 236.48 0 00-6.973-4.576z"
          fill={theme.colors[colorScheme][300]}
        />
        <path
          d="M115.645 98.391H85.133a2.534 2.534 0 01-2.533-2.533V81.496a17.782 17.782 0 0135.558 0v14.362a2.536 2.536 0 01-2.513 2.533zm-27.958-5.067h25.424V81.496a12.715 12.715 0 00-25.424 0v11.828z"
          fill={theme.colors.white}
        />
        <path
          d="M119.557 91.47H80.74v32.802h38.817V91.469z"
          fill={theme.colors.white}
        />
        <path
          d="M104.182 105.091a4.222 4.222 0 00-2.139-3.675 4.229 4.229 0 00-5.785 1.628 4.23 4.23 0 00.092 4.252c.39.637.942 1.16 1.6 1.515l-.71 7.449h5.432l-.709-7.449a4.229 4.229 0 001.624-1.553c.39-.655.596-1.404.595-2.167v0z"
          fill={theme.colors[colorScheme][900]}
        />
      </g>
      <defs>
        <clipPath id={clipPathId01}>
          <path fill={theme.colors.white} d="M0 0h200v200H0z" />
        </clipPath>
      </defs>
    </chakra.svg>
  );
};
